import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import util from '@/libs/util';

const elementLangMap = {
  en: 'en',
  'zh-cn': 'zhCN',
  ar: 'ar',
};

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      if (locale === "en") {
        messages[locale] = {
          ...locales(key),
          ...enLocale
        }
      } else {
        messages[locale] = {
          ...locales(key),
          ...zhLocale
        };
      }
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

Vue.prototype.$languages = Object.keys(messages).map(langlage => ({
  label: messages[langlage].name,
  value: langlage,
}));

// eslint-disable-next-line no-undef
const locale = util.cookies.get('lang') || 'zh-cn';


// VueI18n 为全局引入
Vue.use(VueI18n);
export default new VueI18n({
  locale,
  messages,
});



// WEBPACK FOOTER //
// ./src/i18n.js